// src/index.ts
import { extendBaseTheme } from "@stepstone-genesis/dresscode-base";
import { cwjobs as baseCwjobsTheme } from "@stepstone-genesis/design-tokens";
var cwjobs = extendBaseTheme("cwjobs", baseCwjobsTheme);
export {
  cwjobs
};
